import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "klimahelden-loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle(_ctx.minHeightPx)
    }, _hoisted_3, 4),
    _createVNode(_component_SectionSpacerClouds, {
      ref: "clouds",
      placement: "top",
      class: "mt-0"
    }, null, 512)
  ]))
}